import App from './App';
// import './styles.css';
// import "./styles.scss";
// import TaxCertUploader from './components/TaxCertUploaderNoText';
import TaxCertUploader from './components/TaxCertUploader';
import POUploader from './components/POUploader';
import { renderInto, onReady } from '../utils/render';


function initQuotePortal() {
  const container = document.getElementById('quote_portal') || document.getElementById('root');

  if (!renderInto(container, App, {}, { strict: true })) {
    console.error('Quote Portal: Container element not found!');
  }

  renderInto(
    '#upload_tax_cert',
    TaxCertUploader,
    {
      showCard: true,
      showTitle: true,
      showDescription: false,
      title: 'Upload Tax Exemption',
      message: 'Upload your tax exemption certificate here.',
    },
    { strict: true }
  );

  renderInto(
    '#upload_purchase_order',
    POUploader,
    {
      showCard: true,
      showTitle: true,
      showDescription: true,
      title: 'Purchase Order',
      message: 'Upload your purchase order here. We’ll attach it to this order.',
    },
    { strict: true }
  );
}

onReady(initQuotePortal);
